import React, { useMemo } from 'react';
import { CircleText, Container, StepCircle, StepContainer, StepText } from './OnboardingSteps.styles';
import { useSelector } from 'react-redux';
import { selectUser } from '../../store/slices/user/slice';
import { INFLUENCER_REQUEST_STATUS } from '../../utils/constants';
import { ReactComponent as CheckIcon } from '../../assets/icons/check-01.svg';
import { useLocation } from 'react-router-dom';
import {
  ABOUT_YOU,
  ID_VERIFICATION,
  MEDIA_PRICE,
  PERSONALITY,
  TELEGRAM_INFO,
  UPLOAD_MEDIA,
  UPLOAD_VOICE,
} from '../App/routes';

export const STEP_INDEX = {
  [INFLUENCER_REQUEST_STATUS.EMAIL_VERIFIED]: 0,
  [INFLUENCER_REQUEST_STATUS.REVIEW_IN_PROGRESS]: 1,
  [INFLUENCER_REQUEST_STATUS.REVIEW_ACCEPTED]: 1,
  [INFLUENCER_REQUEST_STATUS.ID_DOCUMENT_VERIFIED]: 2,
  [INFLUENCER_REQUEST_STATUS.TELEGRAM_INFO_CREATED]: 3,
  [INFLUENCER_REQUEST_STATUS.PERSONALITY_CREATED]: 4,
  [INFLUENCER_REQUEST_STATUS.WRITING_STYLE_CREATED]: 5,
  [INFLUENCER_REQUEST_STATUS.MEDIA_UPLOADED]: 6,
  [INFLUENCER_REQUEST_STATUS.MEDIA_PRICE_SET]: 7,
  [INFLUENCER_REQUEST_STATUS.VOICE_UPLOADED]: 8,
  [INFLUENCER_REQUEST_STATUS.APPROVAL_IN_PROGRESS]: 9,
  [INFLUENCER_REQUEST_STATUS.APPROVED]: 9,
};

const OnboardingSteps = () => {
  const user = useSelector(selectUser);
  const { pathname } = useLocation();

  const STEPS = useMemo(() => {
    return [
      {
        text: 'ID Verification',
        finished: STEP_INDEX[user.status] > 1,
        active: pathname === `/${ID_VERIFICATION}`,
      },
      {
        text: 'Telegram',
        finished: STEP_INDEX[user.status] > 2,
        active: pathname === `/${TELEGRAM_INFO}`,
      },
      {
        text: 'Personality',
        finished: STEP_INDEX[user.status] > 3,
        active: pathname.includes(`/${PERSONALITY}`),
      },
      {
        text: 'More About You',
        finished: STEP_INDEX[user.status] > 4,
        active: pathname.includes(`/${ABOUT_YOU}`),
      },
      {
        text: 'Gallery Upload',
        finished: STEP_INDEX[user.status] > 5,
        active: pathname.includes(`/${UPLOAD_MEDIA}`),
      },
      {
        text: 'Media Price',
        finished: STEP_INDEX[user.status] > 6,
        active: pathname.includes(`/${MEDIA_PRICE}`),
      },
      {
        text: 'Voice',
        finished: STEP_INDEX[user.status] > 7,
        active: pathname.includes(`/${UPLOAD_VOICE}`),
      },
    ];
  }, [user, pathname]);

  return (
    <Container>
      {STEPS.map((step, index) => {
        return (
          <StepContainer key={index}>
            <StepCircle $finished={step.finished} $active={step.active}>
              {step.finished ? <CheckIcon stroke="#fff" /> : <CircleText $active={step.active}>{index + 1}</CircleText>}
            </StepCircle>
            <StepText $finished={step.finished} $active={step.active}>
              {step.text}
            </StepText>
          </StepContainer>
        );
      })}
    </Container>
  );
};

export default OnboardingSteps;
